import { TFilter } from "@/app/types/types";
import SelectionFilter from "../shared/inputs/SelectionFilter";

const FiltrationComp = ({
    setSelectedDate,
    setSelectedTab,
    dateOptions,
    neighborOptions,
    placeholderText
}: TFilter) => {
    return (
        <div className="lg:flex-row flex flex-col gap-4 items-center justify-center pb-12">
            <SelectionFilter
                name="sort-by"
                placeholder="Sort by"
                options={dateOptions}
                onChange={(e: any) => setSelectedDate(e.value)}
            />
            <SelectionFilter
                name="filter-type"
                placeholder={placeholderText || "Type"}
                options={neighborOptions}
                onChange={(e: any) => setSelectedTab(e.value)}
            />
        </div>
    );
}

export default FiltrationComp;